import * as Sentry from '@sentry/react';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

export function createQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        Sentry.captureException(error, {
          tags: { error_type: 'react_query_query' },
        });
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        Sentry.captureException(error, {
          tags: { error_type: 'react_query_mutation' },
        });
      },
    }),
    defaultOptions: {
      queries: {
        retry: 0,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
